module.exports = __webpack_public_path__ + "static/media/5 Niranjan SRI Alerts_.cd820808.pdf";